export const weekDays = [
  { value: "MONDAY", labelKey: "planning.scheduleManager.days.MONDAY" },
  { value: "TUESDAY", labelKey: "planning.scheduleManager.days.TUESDAY" },
  { value: "WEDNESDAY", labelKey: "planning.scheduleManager.days.WEDNESDAY" },
  { value: "THURSDAY", labelKey: "planning.scheduleManager.days.THURSDAY" },
  { value: "FRIDAY", labelKey: "planning.scheduleManager.days.FRIDAY" },
  { value: "SATURDAY", labelKey: "planning.scheduleManager.days.SATURDAY" },
  { value: "SUNDAY", labelKey: "planning.scheduleManager.days.SUNDAY" },
];

export const scheduleTypes = [
  { value: "FIXED", labelKey: "planning.scheduleManager.scheduleTypes.FIXED" },
  { value: "FLEXIBLE", labelKey: "planning.scheduleManager.scheduleTypes.FLEXIBLE" },
  { value: "VARIABLE", labelKey: "planning.scheduleManager.scheduleTypes.VARIABLE" },
];

export const cycleTypes = [
  { value: "WEEKLY", labelKey: "planning.scheduleManager.cycleTypes.WEEKLY" },
  { value: "BIWEEKLY", labelKey: "planning.scheduleManager.cycleTypes.BIWEEKLY" },
  { value: "THREE_WEEK", labelKey: "planning.scheduleManager.cycleTypes.THREE_WEEK" },
  { value: "MONTHLY", labelKey: "planning.scheduleManager.cycleTypes.MONTHLY" },
];

export const emptyForm = {
  name: "",
  description: "",
  schedule_type: "FIXED",
  cycle_type: "WEEKLY",
  hours_per_day: 8,
  hours_per_week: 40,
  break_duration_minutes: 60,
  mandatory_breaks: true,
  late_arrival_tolerance_minutes: 15,
  early_departure_tolerance_minutes: 15,
  default_schedule_enabled: false,
  default_days: ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY"],
  default_start_time: "08:00",
  default_end_time: "17:00",
  default_break_start: "12:00",
  default_break_end: "13:00",
  default_break_enabled: true,
};

export const emptySlot = {
  week_day: "MONDAY",
  start_time: "08:00",
  end_time: "17:00",
  break_start: "12:00",
  break_end: "13:00",
  break_enabled: true,
};
